import {Routes, RouterModule} from '@angular/router';

export const routes: Routes = [
  {path: '', redirectTo: 'home', pathMatch: 'full'},
  {path: '**', redirectTo: 'home',  pathMatch: 'full'}
];

export const routing = RouterModule.forRoot(routes, {
    useHash: true
    // ,enableTracing: true // <-- debugging purposes only
    });



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/app.routing.ts